<template>
  <div>
    <!-- <NavBar></NavBar> -->
    <div class="today-score">
      <div>Today’s score</div>
      <div>{{ schedule }}</div>
    </div>
    <div class="scoreboard-box">
      <div
        class="progress-bar"
        :style="{ left: schedule + '%' }"
      >
        <img
          src="../../assets/image/score-icon.png"
          alt=""
        />
        <div></div>
      </div>
      <div class="risky-box">
        <div></div>
        <div>0-50 Risky</div>
      </div>
      <div class="mild-box">
        <div></div>
        <div>50-75 Mild</div>
      </div>
      <div class="safe-box">
        <div></div>
        <div>75-100 Safe</div>
      </div>
    </div>
    <div class="history-score-box">
      <div class="history-score-title">History score</div>
      <div class="history-score-charts">
        <div
          id="chartHistoryScore"
          class="score-charts"
        ></div>
      </div>
      <div class="history-score-sel">
        <div
          class="charts-tab"
          @click="activeTabTiem('Week')"
          :class="{ active: activeTab === 'Week' }"
        >
          Week
        </div>
        <div
          class="charts-tab"
          @click="activeTabTiem('Month')"
          :class="{ active: activeTab === 'Month' }"
        >
          Month
        </div>
        <div
          class="charts-tab"
          @click="activeTabTiem('Season')"
          :class="{ active: activeTab === 'Season' }"
        >
          Season
        </div>
      </div>
    </div>
    <div class="history-events-box">
      <div class="history-events-title">History events</div>
      <div class="history-events-content-box">
        <div
          class="history-events-content"
          v-for="(event, index) in events"
          :key="event.name"
          @click="setActiveIndex(index, event.name)"
        >
          <div class="events-name">{{ event.name }}</div>
          <div
            class="events-img"
            :class="{ active: activeIndex === index }"
          >
            <img
              :src="event.imgSrc"
              alt=""
            />
          </div>
          <div class="events-number">{{ event.number }}</div>
        </div>
      </div>
    </div>
    <div class="history-events-details-box">
      <div class="history-events-details-title">
        {{ events[activeIndex].name }}&nbsp;&nbsp;&nbsp;<span>{{
          events[activeIndex].number
        }}</span>
      </div>
      <div class="history-events-details-charts">
        <div
          class="events-charts"
          id="chartHistoryScoreDetail"
        ></div>
      </div>
    </div>
    <div class="summary-box">
      <div class="summary-title">Summary</div>
      <div class="summary-content">
        Today you drived for
        {{ todayScore.durationMinutes | hourlyFormatting }} hours,
        {{ todayScore.riskyTrips }} of your trips are risky;compared to
        yesterday,
        <span v-if="todayScore.riskyTripsRate > 0">
          increased by{{ todayScore.riskyTripsRate }}%</span>
        <span v-if="todayScore.riskyTripsRate < 0">Reducedby{{ todayScore.riskyTripsRate }}%</span>
        <span v-if="todayScore.riskyTripsRate === 0">Equalto yesterday</span>
        .
      </div>
    </div>
    <!-- <Tabbar></Tabbar> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
import Tabbar from "@/components/Tabbar";
import NavBar from "@/components/NavBar";
import Cookies from "js-cookie";
import {
  driversBehaviors,
  driversBehaviorsLineChart,
  driversBehaviorsEventsChart,
} from "@/api";
export default {
  components: {
    Tabbar,
    NavBar,
  },
  data() {
    return {
      behaviorsEventsData: "", // 驾驶行为数据
      todayScore: "", //今日分数全部信息
      historyScoreData: "", //折线图数据
      historyScoreTime: "", //折线图分数时间
      schedule: 0, //进度条进度
      contents: "",
      activeIndex: 0,
      activeTab: "Week",
      arr: [
        [11.3, 3.4],
        [1.07, 1.95],
        [2.3, 18],
        [3.03, 3.23],
        [2.2, 1.83],
        [1.0, 3.84],
        [3.8, 2.82],
        [2, 1.68],
      ],
      events: [
        {
          name: "Braking",
          imgSrc: require("../../assets/image/braking.svg"),
          number: 0,
        },
        {
          name: "Speeding",
          imgSrc: require("../../assets/image/speeding.svg"),
          number: 0,
        },
        {
          name: "Acc.",
          imgSrc: require("../../assets/image/acc.svg"),
          number: 0,
        },
        {
          name: "Turning",
          imgSrc: require("../../assets/image/turning.svg"),
          number: 0,
        },
        {
          name: "Distracted",
          imgSrc: require("../../assets/image/distracted.svg"),
          number: 0,
        },
        {
          name: "Disc.",
          imgSrc: require("../../assets/image/disc.svg"),
          number: 0,
        },
      ],
    };
  },
  created() { },
  filters: {
    hourlyFormatting(e) {
      // console.log('dadasdasd0------',e,(e / 60).toFixed(1));
      return (e / 60).toFixed(1);
    },
  },
  mounted() {
    // 拿token
    this.contents = Cookies.get("token");
    localStorage.setItem("token",this.contents)

    // localStorage.setItem(
    //   "token",
    //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiT1BFUkFUT1IiLCJjbGllbnRJZCI6IjY2M2FmNWQ5YjkyMjFkNmI0ODA4ODNlZiIsIm1vYmlsZSI6IjE4NjgxNDk5MjEwIiwibmFtZSI6IkFCRFVMIFNVSEFJTUkgQklOIFNBSkFLIiwiZXhwIjoxNzIzMDE0MDc1LCJ1c2VySWQiOiI2Njg2NjM3ZmZjZDcwNTAyNTFkOTEwNGQiLCJpYXQiOjE3MjE4MDQ0NzUsImVtYWlsIjoid3NsMzgzMTA1NjYyQDE2My5jb20iLCJhdXRob3JpdGllcyI6WyJEUklWRVIiXSwidXNlcm5hbWUiOiIxODY4MTQ5OTIxMCJ9.wTtumqVhWIxNx8n_K37yVg1SQtFhd2oUU_rf-jt64ZM"
    // );
    this.ratingBehaviorDayEvent();
    //默认查周
    this.activeTabTiem("Week");
    // 驾驶行为事件统计
    this.setActiveIndex(0, "Braking");
  },
  methods: {
    /**事件统计 */
    setActiveIndex(index, eventsType) {
      var type;
      var max;
      var min;
      var interval;
      this.activeIndex = index;
      // const currentDate = new Date();
      switch (eventsType) {
        // 刹车 -5 —— -0
        case "Braking":
          type = "BRAKING";
          min = -5;
          max = -0;
          interval = 1;
          break;
        // 超速 30 —— 140
        case "Speeding":
          type = "SPEEDING";
          max = 150;
          min = 30;
          interval = 30;
          break;
        // 加速 0 —— 5
        case "Acc.":
          type = "ACCELERATION";
          max = 5;
          min = 0;
          interval = 1;
          break;
        // 急转 0 —— 5
        case "Turning":
          type = "CORNERING";
          max = 5;
          min = 0;
          interval = 1;
          break;
        // 分心 30 —— 140
        case "Distracted":
          type = "DISTRACTION";
          max = 150;
          min = 30;
          interval = 30;
          break;
        // 断联 30 —— 140
        case "Disc.":
          type = "DISCONNECT";
          max = 150;
          min = 30;
          interval = 30;
          break;
      }
      var params = {
        type,
        date: this.formatDate(new Date()),
        // date: "2024-01-23",
      };
      driversBehaviorsEventsChart(params).then((res) => {
        console.log("事件统计", res.data.results);
        var arr = res.data.results
        // var arr=
        var dateArr = arr.map((item) =>
          item.date.substring(item.date.length - 8, item.date.length - 3)
        );
        var dateArrFormatting = dateArr.map((time) => {
          const [hourStr, minuteStr] = time.split(":");
          const hour = parseInt(hourStr, 10);
          const minute = parseInt(minuteStr, 10);
          return hour + minute / 60;
        });
        var valueArr = arr.map((item) => {
          // 先确保将字符串转换为数值类型，然后再调用 toFixed()
          let numericValue = parseFloat(item.value); // 将字符串转换为浮点数
          // console.log('numericValue.toFixed(1)', numericValue.toFixed(1));
          return numericValue.toFixed(1);
        });
        // console.log("dateArr---", dateArr);
        // console.log("valueArr", valueArr);
        // console.log("dateArrFormatting", dateArrFormatting);
        // behaviorsEventsData = res.data.data;
        this.behaviorsEventsData = dateArrFormatting.map((item, index) => [
          item,
          valueArr[index],
          dateArr[index],
        ]);

        // console.log(
        //   "behaviorsEventsData",
        //   this.behaviorsEventsData,
        //   min,
        //   max,
        //   interval
        // );

        this.chartHistoryScoreDetailEvent(min, max, interval);
      });
      // console.log('asdasda---',params);
    },
    /** 折线图筛选 */
    activeTabTiem(e) {
      this.activeTab = e;
      var endDate;
      var size;
      const currentDate = new Date();
      // console.log("当前：", this.formatDate(currentDate));
      switch (e) {
        case "Week":
          const oneWeekAgo = new Date(currentDate);
          oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
          // console.log("前一周的时间：", this.formatDate(oneWeekAgo));
          endDate = this.formatDate(oneWeekAgo);
          size = 7;
          break;
        case "Month":
          const oneMonthAgo = new Date(currentDate);
          oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
          // console.log("前一个月的时间：", this.formatDate(oneMonthAgo));
          endDate = this.formatDate(oneMonthAgo);
          size = 30;
          break;
        case "Season":
          const oneQuarterAgo = new Date(currentDate);
          oneQuarterAgo.setMonth(oneQuarterAgo.getMonth() - 3);
          // console.log("前一个季度的时间：", this.formatDate(oneQuarterAgo));
          endDate = this.formatDate(oneQuarterAgo);
          size = 120;
          break;
      }
      var params = {
        startDate: endDate,
        endDate: this.formatDate(currentDate),
        size,
      };
      driversBehaviorsLineChart(params).then((res) => {
        // console.log("折线图筛选res", res);
        this.historyScoreData = res.data.results.map((v) =>
          Math.round(v.score)
        );
        this.historyScoreTime = res.data.results.map((v) =>
          this.formatDateEnglish(v.date)
        );
        this.chartHistoryScoreEvent();
        // console.log('historyScoreData----,',historyScoreData,historyScoreTime);
        // this.historyScore
      });
    },
    /** 时间格式化英语 */
    formatDateEnglish(dateStr) {
      const date = new Date(dateStr);
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];
      const day = String(date.getDate()).padStart(2, "0");

      return `${month} ${day}`;
    },
    /** 时间格式化 */
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    /**当天数据评分行为 */
    ratingBehaviorDayEvent() {
      var params = {
        date: this.formatDate(new Date()),
        // date: "2024-01-23",
      };
      driversBehaviors(params).then((res) => {
        // console.log("res", res);
        this.todayScore = res.data;
        // 分数
        this.schedule = Math.round(res.data.score);
        this.events.find((event) => event.name === "Braking").number =
          res.data.braking;
        this.events.find((event) => event.name === "Speeding").number =
          res.data.speeding;
        this.events.find((event) => event.name === "Acc.").number =
          res.data.acceleration;
        this.events.find((event) => event.name === "Turning").number =
          res.data.cornering;
        this.events.find((event) => event.name === "Distracted").number =
          res.data.distraction;
        this.events.find((event) => event.name === "Disc.").number =
          res.data.disconnection;
      });
    },
    chartHistoryScoreDetailEvent(min, max, interval) {
      // 获取容器元素
      const chartContainer = document.getElementById("chartHistoryScoreDetail");
      const myChart = echarts.getInstanceByDom(chartContainer);
      // console.log(
      //   "shuju-------",
      //   this.behaviorsEventsData.length,
      //   this.behaviorsEventsData
      // );
      //切换防止每次初始化表格
      if (myChart) {
        myChart.setOption({
          series: [
            {
              data: this.behaviorsEventsData.length > 0 ? this.behaviorsEventsData : [], // Update the data with this.arr
              // data: 

            },
          ],
          yAxis: {
            // min,max,interval,
            min: min,
            max: max,
            interval: interval, // 指定刻度间隔
            position: "right",
            axisLine: {
              lineStyle: {
                color: "#A5AAC1", // 坐标轴线颜色
                width: 0.1, // 坐标轴线宽度
              },
            },

            axisTick: {
              show: false, // 隐藏刻度线
            },
          },
        });
      } else {
        // 基于容器元素初始化 ECharts 实例
        const myChart = echarts.init(chartContainer);
        // 定义图表配置项
        const options = {
          xAxis: {
            type: "value",
            min: 0,
            max: 24,
            interval: 12,
            position: "bottom", // 设置 X 轴刻度线在顶部
            axisLine: {
              lineStyle: {
                color: "#A5AAC1", // 坐标轴线颜色
                width: 0.1, // 坐标轴线宽度
              },
            },
            // 格式化
            axisLabel: {
              formatter: function (value, index) {
                if (value === 0) {
                  return "00:00";
                } else if (value === 12) {
                  return "12:00";
                } else if (value === 24) {
                  return "24:00";
                }
              },
            },
            axisTick: {
              show: false, // 隐藏刻度线
            },
          },
          yAxis: {
            min: min,
            max: max,
            interval: interval, // 指定刻度间隔
            position: "right",
            axisLine: {
              lineStyle: {
                color: "#A5AAC1", // 坐标轴线颜色
                width: 0.1, // 坐标轴线宽度
              },
            },
            axisTick: {
              show: false, // 隐藏刻度线
            },
          },
          grid: {
            left: "5%",
            right: "0%",
            top: "8%",
            bottom: "0%",
            containLabel: true,
          },
          tooltip: {
            show: true, // 显示tooltip
            trigger: "item", // 触发方式为数据项触发
            backgroundColor: "#000", // tooltip背景颜色
            textStyle: {
              color: "#fff",
            },
            borderColor: "transparent",
            formatter: function (params) {
              // 自定义tooltip内容
              // return `X: ${params.data[0]}<br>Y: ${params.data[1]}`;
              // console.log("valueArrpppppp0-0-0--0-0-0-0-0-0", params);
              let time = params.data[2];
              let timeParts = time.split(":");
              let hours = parseInt(timeParts[0], 10);

              let amPm = hours >= 12 ? "pm" : "am";
              if (hours > 12) {
                hours -= 12;
              }
              return (
                `<span style="font-size: 12px;">${params.data[2]} ${amPm}</span><br>` +
                `<span style="font-size: 16px;">${params.data[1]} <span style="font-size: 12px;">km/h</span></span>`
              );
            },
          },
          series: [
            {
              symbolSize: 20,
              data: this.behaviorsEventsData,
              // data: [
              //   [1.3, -3.4],
              //   [1.07, -1.95],
              //   [2.3, -18],
              //   // [3.03, 3.23],
              //   // [2.2, 1.83],
              //   // [1.0, 3.84],
              //   // [3.8, 2.82],
              //   // [2, 1.68],
              //   // [1.3, 3.4],
              //   // [1.07, 1.95],
              //   // [2.3, 18],
              //   // [3.03, 3.23],
              //   // [2.2, 1.83],
              //   // [1.0, 3.84],
              //   // [3.8, 2.82],
              //   // [2, 1.68],
              // ],
              symbolSize: 8, // 点的大小
              itemStyle: {
                color: "#EA4434", // 点的颜色
                emphasis: {
                  itemStyle: {
                    borderColor: "transparent", // Set border color to transparent on hover
                  },
                },
              },
              type: "scatter",
            },
          ],
        };
        // 使用配置项绘制图表
        myChart.setOption(options);
        myChart.resize = true;
      }
    },
    /**折线图 */
    chartHistoryScoreEvent() {
      // 获取容器元素
      const chartContainer = document.getElementById("chartHistoryScore");
      // 基于容器元素初始化 ECharts 实例
      const myChart = echarts.init(chartContainer);
      // 定义图表配置项
      const options = {
        grid: {
          left: "-5%",
          right: "2%",
          top: "3%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          show: false, // 隐藏 x 轴展示条
          type: "category",
          boundaryGap: false,
          data: this.historyScoreTime,
        },
        yAxis: {
          show: false, // 隐藏 y 轴展示条
          type: "value",
        },
        tooltip: {
          show: true, // 显示tooltip
          trigger: "axis", // 触发方式为坐标轴触发
          backgroundColor: "#000", // tooltip背景颜色
          textStyle: {
            color: "#fff",
          },
          formatter: function (params) {
            // console.log(params, "sdasda-------");
            // 自定义tooltip内容
            // return `X: ${params[0].name}<br>Y: ${params[0].value}`;
            return (
              `<span style="font-size: 12px;">${params[0].axisValue}</span><br>` +
              `<span style="font-size: 16px;">${params[0].value} <span style="font-size: 12px;">pts</span></span>`
            );
          },
        },
        series: [
          {
            data: this.historyScoreData,
            type: "line",
            // showSymbol: this.historyScoreData.length === 1 ? true : false,
            showSymbol: true,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "white", // 渐变起始颜色
                  },
                  {
                    offset: 1,
                    color: "#8ddcba", // 渐变结束颜色
                  },
                ],
              },
            },
            lineStyle: {
              color: "#02BF72", // 折线颜色
            },
            symbol: "circle", // 点的样式为实心圆
            symbolSize: 6, // 点的大小
            itemStyle: {
              color: "#02BF72", // 点的颜色
            },
          },
        ],
      };
      // 使用配置项绘制图表
      myChart.setOption(options);
      myChart.resize = true;
    },
  },
};
</script>
<style scoped lang="scss">
// #chartContainer {
//   width: 600px !important;
//   height: 400px !important;
// }
.today-score {
  height: 31px;
  display: flex;
  width: 361px;
  justify-content: space-between;
  align-items: center;
  // 65px
  margin: 16px auto 0 auto;
  // margin-top: 50px;
  div:nth-child(1) {
    width: 135px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #200e32;
    line-height: 25px;
  }
  div:nth-child(2) {
    // width: 67px;
    height: 31px;
    font-size: 26px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #200e32;
    line-height: 31px;
  }
}
.scoreboard-box {
  margin: 22px auto 0 auto;
  width: 361px;
  height: 48px;
  // border: 1px solid;
  display: flex;
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #000000;
  position: relative;
  .progress-bar {
    position: absolute;
    top: -11px;
    // left: 0%;
    width: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    img {
      width: 26px;
      height: 22px;
    }
    div {
      width: 2px;
      height: 18px;
      margin-top: -6px;
      background: rgba(0, 0, 0, 0.25);
    }
  }
  .risky-box {
    width: 181px;
    height: 48px;
    div:nth-child(1) {
      width: 181px;
      height: 24px;
      background: #d45d48;
    }
    div:nth-child(2) {
      width: 179px;
      height: 20px;
      text-align: center;
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      margin-top: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mild-box {
    width: 92px;
    height: 48px;
    div:nth-child(1) {
      width: 92px;
      height: 24px;
      background: #d8dce4;
    }
    div:nth-child(2) {
      width: 90px;
      height: 20px;
      text-align: center;
      margin-top: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .safe-box {
    width: 89px;
    height: 48px;
    div:nth-child(1) {
      width: 89px;
      height: 24px;
      background: #4893d4;
    }
    div:nth-child(2) {
      width: 87px;
      height: 20px;
      text-align: center;
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      margin-top: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.history-score-box {
  width: 361px;
  height: 159px;
  // border: 1px solid;
  margin: 16px auto 13px auto;
  .history-score-title {
    width: 151px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #200e32;
    line-height: 25px;
  }
  .history-score-charts {
    width: 361px;
    height: 96px;
    margin: 6px auto 5px auto;
    .score-charts {
      width: 100%;
      height: 100%;
    }
  }
  .history-score-sel {
    position: relative;
    width: 180px;
    height: 32px;
    display: flex;
    font-size: 10px;
    font-weight: 500;
    color: #98a2b6;
    margin: 0 auto;
    justify-content: space-between;
    .charts-tab {
      height: 22px;
      padding: 0 10px;
      // background: #f0f0f0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 7px;
      // margin-right: 10px;
    }
    .active {
      background: #f0f0f0 !important;
    }
    .charts-tab:nth-child(1) {
      // margin-left: 90px;
    }
  }
}

.history-events-box {
  width: 361px;
  height: 150px;
  // border: 1px solid;
  margin: 0 auto 13px auto;
  .history-events-title {
    width: 151px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #200e32;
    line-height: 25px;
  }
  .history-events-content-box {
    width: 361px;
    height: 113px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 12px;
    display: flex;
    justify-content: space-around;
    .history-events-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 10px;
      .events-name {
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #200e32;
        line-height: 16px;
      }
      .active {
        background-color: #ea4434 !important;
        img {
          filter: brightness(0) invert(1) !important;
          width: 24px;
          height: 24px;
        }
      }
      .events-img {
        width: 44px;
        height: 44px;
        background: #e9e9e9;
        border-radius: 50%;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        margin: 8px 0 4px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .events-number {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #200e32;
        line-height: 17px;
      }
    }
  }
}
.history-events-details-box {
  width: 361px;
  height: 139px;
  // border: 1px solid;
  margin: 12px auto 16px auto;
  .history-events-details-title {
    width: 127px;
    height: 16px;
    font-size: 14px;
    // font-weight: 400;
    color: #200e32;
    line-height: 16px;
    margin-bottom: 12px;
    span {
      font-weight: 600 !important;
    }
  }
  .history-events-details-charts {
    width: 361px;
    height: 111px;
    display: flex;
    justify-content: center;
    .events-charts {
      width: 100%;
      height: 100%;
    }
  }
}
.summary-box {
  width: 361px;
  height: 83px;
  background: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
  .summary-title {
    margin: 10px 0 4px 16px;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #200e32;
    line-height: 25px;
  }
  .summary-content {
    width: 329px;
    height: 34px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #200e32;
    line-height: 17px;
    margin-left: 16px;
  }
}
</style>